<template>
    <div class="hello">
        <div class="visible-md-block visible-lg-block" style="height: 600px;;background: #d8d6d7">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imageBox imageBox1">
                            <div class="center">
                                <div class="text">
                                    <div style="margin-bottom: 33px;">用更好的游戏连接阿拉伯</div>
                                    <div style="font-size: 25px">Connect Arab with Better Games</div>
                                </div>
                                <div class="image">
                                    <img src="../assets/images/banner1s.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                         <div class="imageBox imageBox2">
                             <div class="center">
                                 <div class="text">
                                     <div style="margin-bottom: 33px;">用更好的游戏连接阿拉伯</div>
                                     <div style="font-size: 25px">Connect Arab with Better Games</div>
                                 </div>
                                 <div class="image">
                                     <img src="../assets/images/banner2s.png" alt="">
                                 </div>
                             </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                         <div class="imageBox imageBox3">
                             <div class="center">
                                 <div class="text">
                                     <div style="margin-bottom: 33px;">用更好的游戏连接阿拉伯</div>
                                     <div style="font-size: 25px">Connect Arab with Better Games</div>
                                 </div>
                                 <div class="image">
                                     <img src="../assets/images/banner3s.png" alt="">
                                 </div>
                             </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                         <div class="imageBox imageBox4">
                             <div class="center">
                                 <div class="text" style="color: #4d4d4d">
                                     <div style="margin-bottom: 33px;">用更好的游戏连接阿拉伯</div>
                                     <div style="font-size: 25px">Connect Arab with Better Games</div>
                                 </div>
                                 <div class="image">
                                     <img src="../assets/images/banner4s.png" alt="">
                                 </div>
                             </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                         <div class="imageBox imageBox5">
                             <div class="center">
                                 <div class="text">
                                     <div style="margin-bottom: 33px;">用更好的游戏连接阿拉伯</div>
                                     <div style="font-size: 25px">Connect Arab with Better Games</div>
                                 </div>
                                 <div class="image">
                                     <img src="../assets/images/banner5s.png" alt="">
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
                <!-- Add Arrows -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="visible-sm-block visible-xs-block" style="position: relative">
            <div style="height: 400px;;background: #d8d6d7;width: 100%;overflow: hidden;">
                <div class="swiper-container2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="mimageBox imageBox imageBox1">
                                <!--<img src="../../static/img/mbanner1.jpg" alt="" height="600px">-->
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="mimageBox imageBox imageBox2">
                                <!--<img src="../../static/img/mbanner2.jpg" alt=""  height="600px">-->
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="mimageBox imageBox imageBox3">
                                <!--<img src="../../static/img/mbanner3.jpg" alt="" height="600px">-->
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="mimageBox imageBox imageBox4">
                                <!--<img src="../../static/img/mbanner4.jpg" alt="" height="600px">-->
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="mimageBox imageBox imageBox5">
                                <!--<img src="../../static/img/mbanner5.jpg" alt="" height="600px">-->
                            </div>
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination swiper-pagination2"></div>
                    <!-- Add Arrows -->
                    <!--<div class="swiper-button-next"></div>-->
                    <!--<div class="swiper-button-prev"></div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components: {
        },
        mounted(){
            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                paginationClickable: true,
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                loop : true,
                autoplayDisableOnInteraction: false
            });
            // var swiper2 = new Swiper('swiper-container2', {
            //     pagination: '.swiper-pagination2',
            //     // nextButton: '.swiper-button-next',
            //     // prevButton: '.swiper-button-prev',
            //     paginationClickable: true,
            //     spaceBetween: 30,
            //     centeredSlides: true,
            //     autoplay: 4000,
            //     loop : true,
            //     autoplayDisableOnInteraction: false
            // });
            var swiper2 = new Swiper('.swiper-container2', {
                pagination: '.swiper-pagination2',
                paginationClickable: true
            });
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .hello .swiper-container {
        width: 100%;
        height: 100%;

    }
    .hello .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
    .hello .swiper-slide .imageBox{
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
    }
    .hello .swiper-slide .imageBox.imageBox1{
        background-image: url("../../static/img/banner1.jpg");
    }
    .hello .swiper-slide .imageBox.imageBox2{
        background-image: url("../../static/img/banner2.jpg");
    }
    .hello .swiper-slide .imageBox.imageBox3{
        background-image: url("../../static/img/banner3.jpg");
    }
    .hello .swiper-slide .imageBox.imageBox4{
        background-image: url("../../static/img/banner4.jpg");
    }
    .hello .swiper-slide .imageBox.imageBox5{
        background-image: url("../../static/img/banner5.jpg");
    }
    .hello .swiper-slide .imageBox.mimageBox{
        width: 100%;
        height: 400px;
        background-size: 100% auto;
        background-position: center;
    }

    .hello .swiper-slide .imageBox.mimageBox.imageBox1{
        background-image: url("../../static/img/mbanner1.jpg");
    }
    .hello .swiper-slide .imageBox.mimageBox.imageBox2{
        background-image: url("../../static/img/mbanner2.jpg");
    }
    .hello .swiper-slide .imageBox.mimageBox.imageBox3{
        background-image: url("../../static/img/mbanner3.jpg");
    }
    .hello .swiper-slide .imageBox.mimageBox.imageBox4{
        background-image: url("../../static/img/mbanner4.jpg");
    }
    .hello .swiper-slide .imageBox.mimageBox.imageBox5{
        background-image: url("../../static/img/mbanner5.png");
    }


    .hello .swiper-slide .imageBox .center{
        width: 80%;
        height: 100%;
        margin: 0 auto;
        position: relative;
    }
    .hello .swiper-slide .imageBox .center .text{
        width: 500px;
        position: absolute;
        color: #fff;
        text-align: left;
        font-size: 40px;
        top: 222px;
        z-index: 2;
    }
    .hello .swiper-slide .imageBox .center .image{
        position: absolute;
        top: 88px;
        left: 40%;
    }
    @media (max-width: 1790px){
        .hello .swiper-slide .imageBox{
            background-size: auto 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue